export default "__VITE_ASSET__BavSnlON__"